// ── Investment Sales Engine ───────────────────────────────────────────────────

/** Qty posisi investasi saat ini (lot untuk saham_idx, unit untuk lainnya) */
export function getQty(inv) {
  return inv.type === "saham_idx" ? (inv.lot || 0) : (inv.unit || 0);
}

/** Investasi dengan posisi masih ada (qty > 0) */
export function getActiveInvestments(investments) {
  return investments.filter(i => getQty(i) > 0);
}

/** Investasi yang posisinya sudah habis terjual (qty = 0, tapi masih punya riwayat sale) */
export function getSoldOutInvestments(investments) {
  return investments.filter(i => getQty(i) <= 0);
}

/**
 * Hitung preview hasil jual, dipakai di modal (sebelum konfirmasi) & saat commit.
 * @param {object} inv investasi yang mau dijual
 * @param {number} qty jumlah yang dijual (lot/unit)
 * @param {number} sellPrice harga jual per lot/unit
 * @returns {{ qtyMult, proceeds, costBasis, realizedGain, remainingQty }}
 */
export function calcSalePreview(inv, qty, sellPrice) {
  const qtyMult = inv.type === "saham_idx" ? 100 : 1;
  const proceeds    = qty * qtyMult * sellPrice;
  const costBasis   = qty * qtyMult * (inv.avgPrice || 0);
  const realizedGain = proceeds - costBasis;
  const remainingQty = getQty(inv) - qty;
  return { qtyMult, proceeds, costBasis, realizedGain, remainingQty };
}

/** Total realized gain gabungan semua sale */
export function getTotalRealizedGain(investmentSales) {
  return investmentSales.reduce((a, s) => a + (s.realizedGain || 0), 0);
}
